import React, { useMemo, useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { setErrorPopUp } from "@reducers/notification";
import FullWidthModal from '@components/common/Modal/FullWidthModal';
import { LABEL, CUSTOM_MESSAGES} from '../../../veriables';
import styles from '../orders.module.scss';
import style from '../orderRevamp.module.scss';
import cn from 'classnames';
import { sort} from '@utility/helperFunction';
import { TouchableButton, TouchableDiv } from '@components/common/Touchable'
import ModalHeader from '../../common/ModalHeader/index';
const Modal = React.lazy(() => import('@components/common/Modal'));

const PrintReceiptModal = ({isPrintSelect, serverAppTheme, ...props}) => {
  const [confirmPrint, setConfirmPrint] = useState(false)
  const dispatch = useDispatch();

 useEffect(() => {
    if (confirmPrint) {
        dispatch(setErrorPopUp({
          res: CUSTOM_MESSAGES().SP_SELECT_SEAT_PRINT_ERROR,
          noErrorTxt: true,
        }));
        setConfirmPrint(false);
    }
  }, [confirmPrint, setConfirmPrint, dispatch]);

  const handleSeatSelection = (number) => {
    if (isPrintSelect?.data?.indexOf(number) === -1) {
      props.setIsPrintSelect((state) => { return {isOpen: true, data: [...(state?.data || []), number]?.filter((e) => e !== -1) }; });
    } else {
      props.setIsPrintSelect((state) => {
        return {
          isOpen: true,
          data: state.data?.filter((d) => d !== number)
        };
      });
    }
  };

  const popupModal = useMemo(() => {
    const modalStyle = {
      maxWidth: 'unset',
      backgroundColor: serverAppTheme?.popUp_bg,
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      margin:'auto',
      width: '100%',
      height: '100%'
    };
    const parentContainer = {color: serverAppTheme?.primary_text};
    const tableStyle = {
      padding: props.isOrderingPortrait ? '16px 12px 12px' : '4px 60px 0px',
      alignItems: 'baseline',
    }
    const tableTextStyle = {
      width: props.isOrderingPortrait ? '235px' : '300px',
      height: '2.75rem',
      color: isPrintSelect?.data.some((d) => d === -1) ? '#000' : serverAppTheme?.primary_text,
      border: serverAppTheme?.popupBorder,
      background: isPrintSelect?.data.some((d) => d === -1) ? serverAppTheme?.selected : serverAppTheme?.OFF_Premise_Btn
    }
    const cancelButton = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
      borderRadius: '8px'
    }
    const printButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
      borderRadius: '8px',
      opacity: 1
    }
    const ActionBtnContainer = { padding: props.isOrderingPortrait ? '16px 12px' : '0 60px', bottom : 0}
    const printTile = (item) => {return { height: props.isOrderingPortrait ? '4.75rem' : '5.75rem', color: isPrintSelect?.data.includes(item.number) ? '#000' : serverAppTheme?.primary_text, border: isPrintSelect?.data.includes(item.number) ? 'none' : serverAppTheme?.popupBorder,background: isPrintSelect?.data.includes(item.number) ? serverAppTheme?.selected : serverAppTheme?.unselected} }
    return {modalStyle, parentContainer, tableStyle, tableTextStyle, cancelButton, printButton, ActionBtnContainer, printTile}
  },[serverAppTheme, isPrintSelect?.data])

  return (

      <FullWidthModal
        isOpen={isPrintSelect?.isOpen}
        loading={props.loading}
        isModalCenter
        customClass={cn('w-100')}
        customClass2={cn("w-100 h-100")}
        style={popupModal.modalStyle}
        noBackground
      >
        <div className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100" style={popupModal.parentContainer}>
          <div className='col-12 text-center px-0'>
            <ModalHeader
            isTab={props.check?.tab}
            stationName={props.check?.stationName}
            tileHeader={LABEL().PRINT_RECEIPT_LABEL}
            seatNumber={props.check?.number}
          />
          </div>
          <div className={cn('pt-3 fw-600 text-center',props.isOrderingPortrait ? 'fs_18' : 'fs_16')}>{CUSTOM_MESSAGES().SELECT_SEAT_PRINT}</div>
          <div className={cn("d-flex  flex-column fs-12 justify-content-top", !props.isOrderingPortrait ? 'h-70 mt-2' : 'h-80')} style={popupModal.tableStyle}>
            <div className="d-flex align-self-left row mx-0 mb-3">
              <TouchableButton
                role="presentation"
                className={cn(isPrintSelect?.data.some((d) => d === -1) ? '' : 'btn-ripple', 'rounded px-4 py-3-5 text-center d-flex justify-content-center align-items-center', props.isOrderingPortrait ? 'fs_20' : 'fs_18')}
                onClick={(event) => { event.preventDefault();props.setIsPrintSelect({ isOpen: true, data: [-1] }); }}
                style={popupModal.tableTextStyle}
              >
                {LABEL().TABLE}
              </TouchableButton>
            </div>
            <div className={cn( props.isOrderingPortrait ? styles.gapPortrait: styles.gapLandscape,styles.wrapper, "overflowY align-items-center w-100")}>
            {props?.check?.seats?.length > 0 && sort(props.check.seats, 'number').map((item) => {
                return item.open && item.number && (
                  <TouchableDiv
                    role="presentation"
                    key={item.number}
                    className={cn(isPrintSelect.data.length > 0 && isPrintSelect?.data.includes(item.number) ? style.selectedSeatsColor : '', 'rounded flex-column text-center fs_20 fw-600 d-flex justify-content-center align-items-center p-1 w-100')}
                    onClick={() => handleSeatSelection(item.number)}
                    style={popupModal.printTile(item)}
                    rippleEffect={true}
                  >
                    <div>{item.number}</div>
                    {item.name ? (
                      <div className={styles.truncate}>
                        {item?.name}
                        </div>
                    ) : '' }
                  </TouchableDiv>
                );
              })}
            </div>
          </div>
          <div className={cn('col-12 row mx-0 justify-content-center align-items-center text-center w-100',props.isOrderingPortrait ? 'position-absolute' : 'position-relative h-15')} style={popupModal.ActionBtnContainer}>
            <div className={cn('col-6 pl-0 pr-1')}>
              <TouchableButton className={cn("fs_24 fw-600 col-12 px-0",props.isOrderingPortrait ? 'btn68' : 'btn44')} type="button"  onClick={(event) => {event.preventDefault();
               props.setIsPrintSelect({ isOpen: false, data: [] });
                }}
                style={popupModal.cancelButton}
                rippleEffect={true}
              >
                {LABEL().CANCEL}
              </TouchableButton>
            </div>
            <div className={cn( 'col-6 pl-1 pr-0')}>
              <TouchableButton className={cn("fs_24 fw-600 col-12 px-0",props.isOrderingPortrait ? 'btn68' : 'btn44')} type="button"  onClick={() => { if(isPrintSelect?.data.length === 0) {setConfirmPrint(true)} else {props.print(isPrintSelect?.data); }}}
                style={popupModal.printButton}
                rippleEffect={true}
              >
                {LABEL().PRINT}
              </TouchableButton>
            </div>
          </div>
        </div>
      </FullWidthModal>
  )
}

export default PrintReceiptModal;